import { OnInit, Component, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { Util } from 'src/shared/util';
import * as _ from 'lodash';
import { Platform } from '@angular/cdk/platform';
import { ApiService } from 'src/shared/api.service';

@Component({
    selector: 'app-validations-error-list',
    templateUrl: './validations-error-list.component.html',
    styleUrls: ['./validations-error-list.component.scss']
})

export class ValidationsErrorListComponent implements OnInit {
    @Input() validationErrors: any;
    @Output() selectedError: EventEmitter<any> = new EventEmitter<any>();
    isDesktop = true;
    objectKeys: any = Object.keys;
    util = Util;

    messageValidator = {} as any;
    @Input() customMessage = {} as any;

    constructor(private pl: Platform, private apiService: ApiService) {
        this.isDesktop = (this.pl.isBrowser && !(this.pl.ANDROID || this.pl.IOS))
        this.getProductTypeConfig();
    }

    ngOnInit() {
    }

    mapValidationErrorsToArray(): any[] {
      if(!this.isReady()){
        return [] as any;
      }
      const arrayValidationErrors = []
      _.each(this.validationErrors, (err, key) => {       
          const controlName =  _.includes(key, ";") ? key.split(';')[1] :  key.split('$')[1];
          const validatorItem =  Object.prototype.hasOwnProperty.call(this.messageValidator, controlName) 
          ? this.messageValidator[controlName] 
          : null;
          const index = validatorItem ? validatorItem.index : -1;
          arrayValidationErrors.push({ index: index, key : key, error: err });
      });
      arrayValidationErrors.sort((a, b) => a.index - b.index);
      return arrayValidationErrors;
    }

    focusControl(key) {
        this.selectedError.emit(key);
    }

    getProductTypeConfig() {
        this.apiService.getProductTypeConfig().subscribe(config => {
            this.messageValidator = config["messageValidator"];
        })
    }

    getMessageValidator(formControl) {
      if (!this.isReady()) {
          return '';
      }
      const controlName = formControl.key.includes(";") ? formControl.key.split(';')[1]  : formControl.key.split('$')[1];
      
      const controlValue = Object.keys(formControl.error)[0];
      if (this.customMessage?.[controlName]?.[controlValue]) {
          return this.customMessage[controlName][controlValue];
      } 
       if (this.messageValidator?.[controlName]?.messages?.[controlValue.toLowerCase()]) {
        return this.messageValidator[controlName].messages[controlValue.toLowerCase()]
      }
      return ''
  }
  
    isReady(): boolean {
      const hasValidationErrors = this.validationErrors && Object.keys(this.validationErrors).length > 0;
      const hasMessageValidator = this.messageValidator && Object.keys(this.messageValidator).length > 0;
      const hasCustomMessage = this.customMessage && Object.keys(this.customMessage).length > 0;

      return hasValidationErrors && (hasMessageValidator || hasCustomMessage);
  }
  
}